module.exports = __webpack_public_path__ + "static/nft-20e2a56c431db9431f054888bf825164.svg";